<template lang="html">
	<div grecaptcha></div>
</template>

<script>
module.exports = {
	name: 'grecaptcha',

	props: [
		'request',
		'payload'
	],

	data() {
		return {
			grcID: null
		}
	},

	computed: {
		fields() {
			return this.payload;
		}
	},

	watch: {
		fields() {
			this.init();
		}
	},

	methods: {
		init() {

			let logic = () => {
				// console.log('BEFORE', this.grcID);
				if(this.grcID == null) {
					this.grcID = grecaptcha.render(this.$el, {
					sitekey: window.YAMASTERS_FRONTEND.googleRecaptchaInvisible.siteKey,
					size: 'invisible',
					badge: 'inline',
					callback: () => {
						let payload = this.request || {};
						// console.log(payload);

						for (var name in this.fields) {
							if (this.fields.hasOwnProperty(name)) {
								payload[name] = this.fields[name];
							}
						}

						console.log('!!!!!!!!!!!!');
						console.log(payload);
						console.log(this.grcID);

						this.$emit('SENDFORM', payload);

						grecaptcha.reset(this.grcID);
					}
				});
				}

				// console.log('AFTER', this.grcID);

				grecaptcha.execute(this.grcID)
			}

			if(window.GRECAPTCHA_IS_LOADED) {
				logic();
			}
			else {
				let iv = setInterval(() => {
					if(window.GRECAPTCHA_IS_LOADED) {
						logic();
						clearInterval(iv);
					}
				}, 50);
			}
		}
	},

	mounted() {



	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// grecaptcha.vue?1966a932